import Components from './components'

export var treeData = new Components.JsonSchemaComponent()

export default treeData



// WEBPACK FOOTER //
// ./src/components/json-schema-editor/treeData.js